import { useState, useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import TimeDisplay from './time-display';
import Button from '@mui/material/Button';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { stopwatchState } from 'store/atoms';
import { useLocalStorage } from 'hooks/localstorage';
import { CSVLink, CSVDownload } from "react-csv";
import moment from 'moment';
export default function History({ t = () => { } }) {
    const [editing, setEditing] = useState(0);
    const [lsstopwatch, setLsstopwatch] = useLocalStorage("stopwatch", { currenttime: null, history: [] });
    const setStopwatch = useSetRecoilState(stopwatchState);
    const stopwatch = useRecoilValue(stopwatchState);

    const handleEdit = (e) => {
        if (e.target.checked) {
            setEditing(1);
        } else {
            setEditing(0);
        }
    }

    const removeItem = (index) => {
        const _stopwatch = { ...stopwatch };
        const need_2_update = {
            ..._stopwatch,
            history: [..._stopwatch.history].filter((v, i) => i !== index)
        };
        setStopwatch(need_2_update);
        setLsstopwatch(need_2_update);
    }

    const handleComment = (e, j) => {
        const need_2_update = {
            ...stopwatch,
            history: [...stopwatch.history.map((v, i) => {
                if (i === j) {
                    return {
                        ...v,
                        comment: e.target.value
                    }
                } else {
                    return v;
                }
            })]
        };
        setStopwatch(need_2_update);
        setLsstopwatch(need_2_update);
    }

    useEffect(() => {
        if (stopwatch.history.length === 0 && lsstopwatch && lsstopwatch.history.length > 0) {
            setStopwatch({ currenttime: null, history: [...lsstopwatch.history] });
        }
    }, []);

    const array_of_totals = stopwatch.history && stopwatch.history.map(v => v.totalTimeMs);

    const is_max = stopwatch.history && Math.max(...array_of_totals);
    const max_index = array_of_totals.indexOf(is_max);

    const is_min = stopwatch.history && Math.min(...array_of_totals);
    const min_index = array_of_totals.indexOf(is_min);

    const headers = [
        { label: "#", key: "id" },
        { label: t('Lap'), key: "lap" },
        { label: t('total'), key: "total" },
        { label: t('comments'), key: "comment" },
        { label: t('Time recorded'), key: "time_recorded" }
    ];


    const formatTime = (val, ...rest) => {

        let value = val.toString();
        if (value.length < 2) {
            value = '0' + value;
        }
        if (rest[0] === 'ms' && value.length < 3) {
            value = '0' + value;
        }
        return value;
    };
    const obj2date = (currenttime) => {
        return (
            `${formatTime(currenttime.currentTimeHr)}: ${formatTime(currenttime.currentTimeMin)}: ${formatTime(currenttime.currentTimeSec)}.${formatTime(currenttime.currentTimeMs, 'ms')}`
        )
    }
    let history = stopwatch ? stopwatch.history : [];

    history = history.map((v, i) => {
        return {
            id: history.length - i,
            lap: obj2date(v),
            total: obj2date(v.totaltime),
            comment: v.comment,
            time_recorded: moment(v.time_recorded).format('ddd, MMMM D YYYY, hh:mm:ss.SSS')
        }
    });




    return (
        <div className={`stopwatch-history-container`}>
            <div className="history-header">
                <div className="edit-laps">
                    <FormControlLabel
                        value={editing}
                        control={<Checkbox color='success' onChange={handleEdit} />}
                        label={t('Edit laps')}
                        labelPlacement="end"
                    />
                </div>
                <div className="export-laps">
                    <CSVLink data={history} headers={headers} filename={"lap-history.csv"}>
                        <Button onClick={() => { }} variant="outlined" color="success" startIcon={<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M22 8L18 4V7H9V9H18V12M0 14V2C0 0.89 0.9 0 2 0H14C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V5H14V2H2V14H14V11H16V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14Z" fill="#60B475" />
                        </svg>
                        }>
                            {t("export")}
                        </Button>
                    </CSVLink>
                </div>

            </div>
            <div className="history-list">
                <table>
                    <thead>
                        <tr>
                            <th>{t('order')}</th>
                            <th style={{ paddingLeft: "16px" }}>{t('Lap')}</th>
                            <th>{t('total')}</th>
                            <th className='key_comments'>{t('comments')}</th>
                            <th className='key_time_recorded'>{t('#')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stopwatch && stopwatch.history && stopwatch.history.map((v, i) => {
                            return (<tr key={i}>
                                <td>{i + 1}</td>
                                <td className="middle-td" style={{ paddingLeft: "16px" }}><TimeDisplay is_max={max_index === i} is_min={min_index === i} currenttime={v} /></td>
                                <td className="middle-td"><TimeDisplay currenttime={v.totaltime} /></td>

                                <td className='key_comments'>
                                    {editing === 1 && <FormControl className='comment-input' variant="standard">
                                        <div className='field'>
                                            <TextField
                                                className="text-input"
                                                value={v?.comment || ''}
                                                onBlur={(e) => handleComment(e, i)}
                                                onChange={(e) => handleComment(e, i)}
                                            />
                                        </div>
                                    </FormControl>}
                                    {editing === 0 && v?.comment}
                                </td>
                                <td className=" key_time_recorded">
                                    <div className='delete-icon'>
                                        <div className="circle" onClick={() => removeItem(i)}>
                                            {(<svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.50004 0.5V1.33333H0.333374V3H1.16671V13.8333C1.16671 14.2754 1.3423 14.6993 1.65486 15.0118C1.96742 15.3244 2.39135 15.5 2.83337 15.5H11.1667C11.6087 15.5 12.0327 15.3244 12.3452 15.0118C12.6578 14.6993 12.8334 14.2754 12.8334 13.8333V3H13.6667V1.33333H9.50004V0.5H4.50004ZM2.83337 3H11.1667V13.8333H2.83337V3ZM4.50004 4.66667V12.1667H6.16671V4.66667H4.50004ZM7.83337 4.66667V12.1667H9.50004V4.66667H7.83337Z" fill="#444D67" />
                                            </svg>
                                            )}
                                        </div>
                                    </div>
                                </td>
                            </tr>)
                        })
                        }
                    </tbody>
                </table>
            </div>
        </div>

    );

}
